module.exports = __webpack_public_path__ + "Roboto-Bold.39b2c3031be6b4ea96e2.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/font/roboto/Roboto-Bold.woff2
// module id = ../../../../angular-bootstrap-md/font/roboto/Roboto-Bold.woff2
// module chunks = 3